import React, { Component } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import ConditionalWrapper from './ConditionalWrapper'
import DropChildrenMotion from './DropChildrenMotion'
import Item from './Item'
import ItemImage from './ItemImage'
import WallsPinkImage from '../assets/images/bedroom/walls--pink@3x.png'
import LightsOutImage from '../assets/images/bedroom/lights-out@3x.png'
import ItemBed from './items/bedroom/Bed'
import ItemChair from './items/bedroom/Chair'
import ItemDesk from './items/bedroom/Desk'
import ItemDoor from './items/bedroom/Door'
import ItemFan from './items/bedroom/Fan'
import ItemLamp from './items/bedroom/Lamp'
import ItemLaptop from './items/bedroom/Laptop'
import ItemPlant from './items/bedroom/Plant'
import ItemRug from './items/bedroom/Rug'
import ItemSwitch from './items/bedroom/Switch'
import ItemWindow from './items/bedroom/Window'
import ItemChloe from './items/bedroom/Chloe'
import ItemSpeakers from './items/bedroom/Speakers'

const Container = styled.div`
  position: relative;
  pointer-events: none;
`

const LightsOutItemImage = styled(ItemImage)`
  opacity: ${p => (p.switchWasClicked ? 0.3 : 0)};
  animation: ${p =>
      p.switchWasClicked ? p.theme.animation.temporaryFade : 'none'}
    2.5s 1 linear forwards;
`

export default class RoomLiving extends Component {
  static propTypes = {
    dropChildrenMotion: PropTypes.bool,
    onItemClick: PropTypes.func,
    pendingHighlightIds: PropTypes.arrayOf(PropTypes.string),
    successHighlightIds: PropTypes.arrayOf(PropTypes.string),
  }

  static defaultProps = {
    dropChildrenMotion: true,
    onItemClick: id => console.log(`clicked ${id}`),
    pendingHighlightIds: [],
    successHighlightIds: [],
  }

  static items = [
    {
      id: 'rug',
      component: ItemRug,
      left: 12.39,
      bottom: 6.53,
      width: 69.17,
    },
    {
      id: 'desk',
      component: ItemDesk,
      left: 29.81,
      bottom: 35.91,
      width: 31.65,
    },
    {
      id: 'bed',
      component: ItemBed,
      left: 4.29,
      bottom: 11.26,
      width: 58.22,
    },
    {
      id: 'chair',
      component: ItemChair,
      left: 47.91,
      bottom: 37.56,
      width: 9.87,
    },
    {
      id: 'plant',
      component: ItemPlant,
      left: 45.88,
      bottom: 55.36,
      width: 6.44,
    },
    {
      id: 'speakers',
      component: ItemSpeakers,
      left: 38.17,
      bottom: 47.25,
      width: 14.43,
      animate: true,
    },
    {
      id: 'laptop',
      component: ItemLaptop,
      left: 42.75,
      bottom: 46.93,
      width: 10.15,
    },
    {
      id: 'lamp',
      component: ItemLamp,
      left: 33.25,
      bottom: 47.92,
      width: 6.07,
    },
    {
      id: 'window',
      component: ItemWindow,
      left: 17.89,
      bottom: 50.77,
      width: 31.63,
    },
    {
      id: 'fan',
      component: ItemFan,
      left: 33.06,
      bottom: 64.0,
      width: 34.05,
    },
    {
      id: 'door',
      component: ItemDoor,
      left: 74.53,
      bottom: 28.74,
      width: 17.23,
    },
    {
      id: 'switch',
      component: ItemSwitch,
      left: 71.1,
      bottom: 51.16,
      width: 2.82,
    },
  ]

  shouldAnimate(id) {
    const { animateIds } = this.props

    return animateIds.includes(id)
  }

  shouldShowHighlight(id) {
    const {
      pendingHighlightIds: pending,
      successHighlightIds: success,
    } = this.props

    return pending.includes(id) || success.includes(id)
  }

  getHighlightType(id) {
    const {
      pendingHighlightIds: pending,
      successHighlightIds: success,
    } = this.props

    if (pending.includes(id)) return 'pending'
    if (success.includes(id)) return 'success'

    return null
  }

  renderItem(item) {
    const { onItemClick } = this.props
    const { id, component: Comp, left, bottom, width, animate = false } = item

    return (
      <Item
        left={left}
        bottom={bottom}
        width={width}
        key={'RoomLiving__Item--' + id}
      >
        <Comp
          animate={this.shouldAnimate(id) || animate}
          highlight={this.shouldShowHighlight(id)}
          highlightType={this.getHighlightType(id)}
          onClick={() => onItemClick(id)}
        />
      </Item>
    )
  }

  render() {
    const {
      children,
      dropChildrenMotion,
      onItemClick,
      switchWasClicked,
      ...props
    } = this.props

    return (
      <Container {...props}>
        <ItemImage src={WallsPinkImage} />
        <ConditionalWrapper
          condition={dropChildrenMotion}
          wrapper={DropChildrenMotion}
        >
          {RoomLiving.items.map(this.renderItem.bind(this))}
          <Item width={100} left={0} bottom={0}>
            <LightsOutItemImage
              switchWasClicked={switchWasClicked}
              src={LightsOutImage}
            />
          </Item>
          {children}
        </ConditionalWrapper>
      </Container>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/RoomBedroom.js